/**
 * Add icon into shop by button
 */
(() => {
  const shopby = document.querySelector('.header-full .menu .cd-dropdown-trigger');
  if (!shopby) return;

  shopby.insertAdjacentHTML('afterbegin', /* html */ `
    <div class="shopby-icon">
      <span class="shopby-bar1"></span>
      <span class="shopby-bar2"></span>
      <span class="shopby-bar3"></span>
    </div>
  `);
})();

/**
 * Add body class if hero. Makes header transparent & moves hero up.
 */
(() => {
  if (document.querySelector('.transparent-header')) {
    document.body.classList.add('ex-hero');
  } else if (document.querySelector('.ex-content-page')) {
    document.body.classList.add('ex-no-hero');
  }
})();

/**
 * remove buying for business register page
 */
(() => {
  const register = document.querySelector('.ex-register');
  if (!register) return;

  const businessCheckbox = register.querySelector('.allowBusinessAccount_wrapper');
  const businessCheckboxInput = register.querySelector('.company_organisation_wrapper');
  businessCheckbox.remove();
  businessCheckboxInput.remove();
})();

/**
 * Contact Form Upload
 */
(() => {
  const query = document.querySelector('.uploadbutton');
  if (!query) return;

  const logoUpload = (file) => {
    const formData = new FormData();
    formData.append('file', file);

    $.ajax({
      method: 'post',
      url: '/ajax/upload-file',
      data: formData,
      processData: false,
      contentType: false,
    }).then((response) => {
      if (response.status === 'success') {
        const { filepath } = response.data;
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = (() => {
          document.querySelector('.documentupload').value = filepath;
        });
      }
    });
  };

  query.addEventListener('change', (e) => {
    if (!e.target.files) return;

    logoUpload(e.target.files[0]);
  });

  // Remove button functionality
  const area = document.querySelector('.custom-upload-area button');
  const removeButton = document.querySelector('.custom-upload-area .remove.nButton');
  const input = document.querySelector('input.uploadbutton');
  if (removeButton) {
    removeButton.addEventListener('click', () => {
      input.value = '';
      document.querySelector('.documentupload').value = '';
      area.querySelector('.file').innerText = 'Please Upload a File';
      area.querySelector('.file').classList.remove('has-file');
    });
  }
})();

/**
 * hide rewards, compare and chat when footer is observed
 */
(() => {
  setTimeout(() => {
    const footer = document.querySelector('.footersection-2');
    const addressPage = document.querySelector('#addresseslist');
    if (!footer || addressPage) return;

    const rewards = document.querySelector('.rewards-tab');
    const chat = document.querySelector('#chat-widget-container');
    const compare = document.querySelector('.floating-buttons');

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          if (rewards) {
            rewards.classList.add('hide');
          }
          if (chat) {
            chat.classList.add('hide');
          }
          if (compare) {
            compare.classList.add('hide');
          }
        } else {
          if (rewards) {
            rewards.classList.remove('hide');
          }
          if (chat) {
            chat.classList.remove('hide');
          }
          if (compare) {
            compare.classList.remove('hide');
          }
        }
      });
    });

    observer.observe(footer);
  }, 5000);
})();

/**
 *  ECOMM02-4184
 *  Logged-out: replace "Contact Procurement to Order" with a
 * "Login for Pricing" link that opens the login modal
 */
(() => {
  const moduleSelector = '.ex-loggedout .price-call';

  const convertPriceCall = () => {
    if (!document.body.classList.contains('ex-loggedout')) return;

    document.querySelectorAll(`${moduleSelector}:not(.js-call-for-pricing)`).forEach((el) => {
      el.classList.add('js-call-for-pricing');
      el.innerHTML = /* html */ `
        <a href="#" data-toggle="modal" data-target="#loginModal">
          <i class="fa fa-phone" aria-hidden="true"></i>
          <span>Login for Pricing</span>
        </a>
      `;
    });
  };

  try {
    convertPriceCall();
    document.addEventListener('live-pricing-done', convertPriceCall, false);
    document.addEventListener('product-loadmore-success', convertPriceCall, false);
    document.addEventListener('product-quickview-success', convertPriceCall, false);
  } catch (error) {
    console.error(`Error: ${moduleSelector}`, error);
  }
})();
